/**
 * JavaScript Document
 * Version: 1.0.0
 * Date: 7/28/2020
 * Author: Liu Changkun
 * Copyright: www.east.net
 */

import UTIL from "@/api/sync/util";

const init = async store => {
  let response;
  response = await UTIL.DESCRIPTORS();
  if (response.data.state) {
    store.dispatch("setDescriptors", response.data.descriptors);
  }
  response = await UTIL.OPTIONS();
  if (response.data.state) {
    store.dispatch("setOptions", response.data.options);
  }
  response = await UTIL.SCHEMAS();
  if (response.data.state) {
    store.dispatch("setSchemas", response.data.schemas);
  }
  store.dispatch("ready");
};
export default init;
